import React, { useEffect, useMemo, useState } from "react";
import InputField from "common/customInputField";
import { Link, useSearchParams } from "react-router-dom";
import Button from "react-bootstrap/Button";
import debounce from "lodash/debounce";
import omitBy from "lodash/omitBy";
import warning from "svg/warning.svg";

const SearchFields = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [fieldValues, setFieldValues] = useState(() => Object.fromEntries(searchParams.entries()));

  useEffect(() => {
    setFieldValues(Object.fromEntries(searchParams.entries()));
  }, [searchParams]);

  const debouncedSetSearchParams = useMemo(
    () => debounce((values) => setSearchParams(values, { replace: true }), 300),
    [setSearchParams],
  );

  const handleChange = (e) => {
    const { id: key, value } = e.target;
    const nextValues = omitBy({ ...fieldValues, [key]: value }, (v) => v === "");

    setFieldValues(nextValues);
    debouncedSetSearchParams(nextValues);
  };

  return (
    <div className="search-form-container">
      <div className="search-form-container__title d-flex justify-content-between flex-row">
        <span className="fs-4 fw-bold">Quote Search</span>
        <Link to="createQuote" className="create-quote-btn">
          <Button variant="outline-primary" onClick={() => true}>
            Create a new Quote
          </Button>
        </Link>
      </div>
      <div className="d-flex mb-4">
        <img src={warning} alt="warning-icon" className="me-2" />
        Results update automatically
      </div>
      <div className="row">
        <div className="col-4 mb-4">
          <InputField
            type="text"
            label="User ID"
            id="createdBy"
            placeholder="Enter User ID"
            fieldClasses="form-control search-form-container__fields__form-group__item"
            value={fieldValues.createdBy ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-4 mb-4">
          <InputField
            type="text"
            label={"Quote ID"}
            placeholder={"Enter Quote Id"}
            id="quoteId"
            fieldClasses="form-control search-form-container__fields__form-group__item"
            value={fieldValues.quoteId ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-4 mb-4">
          <InputField
            type="text"
            label="Quote Name"
            placeholder="Enter a name"
            id="quoteName"
            fieldClasses="form-control search-form-container__fields__form-group__item"
            value={fieldValues.quoteName ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-4 mb-4">
          <InputField
            type="text"
            label="Store Number"
            placeholder="Enter a number"
            id="storeNumber"
            fieldClasses="form-control search-form-container__fields__form-group__item"
            value={fieldValues.storeNumber ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-4 mb-4">
          <InputField
            type="text"
            label="Sales Rep Name"
            placeholder="Enter a name"
            id="salesRep"
            fieldClasses="form-control search-form-container__fields__form-group__item"
            value={fieldValues.salesRep ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-4 mb-4">
          <InputField
            type="date"
            label="Updated Date Start"
            placeholder="Select a Date"
            id="startDate"
            fieldClasses="form-control search-form-container__fields__form-group__item"
            value={fieldValues.startDate ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-4 mb-4">
          <InputField
            type="text"
            label="Account Number"
            placeholder="Enter a number"
            id="accountNumber"
            fieldClasses="form-control search-form-container__fields__form-group__item"
            value={fieldValues.accountNumber ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-4 mb-4">
          <InputField
            type="text"
            label="Account Name"
            placeholder="Enter a name"
            id="accountName"
            fieldClasses="form-control search-form-container__fields__form-group__item"
            value={fieldValues.accountName ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-4 mb-4">
          <InputField
            type="date"
            label="Updated Date End"
            placeholder="Select a Date"
            id="endDate"
            fieldClasses="form-control search-form-container__fields__form-group__item"
            value={fieldValues.endDate ?? ""}
            onChange={handleChange}
          />
        </div>

        <div className="col-4 mb-4">
          <InputField
            type="text"
            label="Parent Number"
            placeholder="Enter a number"
            id="parentNumber"
            fieldClasses="form-control search-form-container__fields__form-group__item"
            value={fieldValues.parentNumber ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-4 mb-4">
          <InputField
            type="text"
            label="Parent Name"
            placeholder="Enter a name"
            id="parentName"
            fieldClasses="form-control search-form-container__fields__form-group__item"
            value={fieldValues.parentName ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className=" col-4 mb-4">
          <InputField
            type="text"
            label="Contact Phone Number"
            id="phone"
            placeholder="Enter a phone number"
            fieldClasses="form-control search-form-container__fields__form-group__item"
            value={fieldValues.phone ?? ""}
            onChange={(e) => {
              handleChange({
                target: {
                  id: "phone",
                  value: e.target.value.replace(/\D/g, "").substring(0, 10),
                },
              });
            }}
          />
        </div>
      </div>
      <Button
        variant="outline-primary"
        onClick={() => {
          debouncedSetSearchParams.cancel();
          setSearchParams({}, { replace: true });
        }}
      >
        Clear
      </Button>
    </div>
  );
};

export default SearchFields;
